<section class="privacy section">
  <div class="shell-container privacy__grid">
    <div class="privacy__intro">
      <div class="badge">Privacy Policy</div>
      <h1>How we care for your information</h1>
      <p class="privacy__lede">
        Ruffles &amp; Shine respects your privacy. This policy explains what we collect, how we use it,
        and the choices you have.
      </p>
      <p class="privacy__meta">Last updated: January 29, 2026</p>
    </div>

    <div class="privacy__content">
      <h2>Information we collect</h2>
      <p>
        We only collect information needed to provide grooming services and communicate clearly with pet
        parents. This may include your name, contact details, pet information, and appointment notes.
      </p>

      <h2>How we use your information</h2>
      <ul>
        <li>To schedule, manage, and confirm appointments.</li>
        <li>To share updates about your pet during their visit.</li>
        <li>To provide recommendations tailored to your petâ€™s needs.</li>
        <li>To improve service quality and studio operations.</li>
      </ul>

      <h2>How we protect your data</h2>
      <p>
        We use secure systems and limited access controls. Only trained team members can view your
        information, and only when needed for your petâ€™s care.
      </p>

      <h2>Sharing and third parties</h2>
      <p>
        We do not sell your data. We only share information with trusted providers that help us run our
        booking, communication, or payment systemsâ€”and only when required.
      </p>

      <h2>Your choices</h2>
      <p>
        You can request access, updates, or deletion of your information at any time. Contact us and we
        will respond promptly.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about privacy? Email us at
        <a href="mailto:hello@rufflesandshinegrooming.co.uk">hello@rufflesandshinegrooming.co.uk</a>.
      </p>
    </div>
  </div>
</section>
